import { CoreBox, CoreTypography } from '@youscience/core';

import ActionButton from '@components/ActionButton';

import { sxStyles, StyledBannerInner, StyledBannerText } from './Banner.styles';

interface BannerProps {
  onOpenSchoolSelection: () => void;
}

export const Banner = (props: BannerProps) => {
  const { onOpenSchoolSelection } = props;

  return (
    <CoreBox sx={sxStyles.bannerBg}>
      <StyledBannerInner>
        <StyledBannerText>
          <CoreTypography sx={sxStyles.title} variant="h4" component="h3">
            Have you graduated high school and enrolled in college?
          </CoreTypography>

          <CoreTypography variant="subtitle1" component="h2">
            Find your university or technical college, share your results, and explore majors and programs at your
            college if you have already enrolled.
          </CoreTypography>
        </StyledBannerText>

        <ActionButton
          data-testid="claimYourSchoolBtn"
          sx={sxStyles.button}
          variant="outlined"
          size="large"
          onClick={onOpenSchoolSelection}
        >
          Claim my school
        </ActionButton>
      </StyledBannerInner>
    </CoreBox>
  );
};
